// ─── CONSTANTS & STATIC DATA ─────────────────────────────────────────

// ─── ORG SETTINGS (Admin configures these) ───────────────────────────
export const DEFAULT_ORG = {
  name: "Founders Bridge LLP",
  email: "info@foundersbridge.in",
  phone: "+91 98000 00001",
  address: "Mumbai, Maharashtra",
  gstin: "27AABCF1234A1Z5",
  pan: "AABCF1234A",
  sac: "998211",
  logo: null,
  logoUrl: "",
  gstRate: 18,
  bankName: "HDFC Bank",
  accountNo: "XXXXXXXXXXXX",
  ifsc: "HDFC0000001",
  upi: "foundersbridge@hdfc",
};

export const DEFAULT_MARKETPLACE_SERVICES = [
  { id: "ms1", category: "GST", name: "GST Registration", price: 2500, desc: "GSTIN registration for your business", shortName: "GST Reg", icon: "analytics" },
  { id: "ms2", category: "GST", name: "GST Return Filing (Annual)", price: 12000, desc: "All GST returns for 12 months", shortName: "GST Return", icon: "analytics" },
  { id: "ms3", category: "Compliance", name: "Annual ROC Compliance", price: 8000, desc: "Annual return filing with MCA", shortName: "ROC Comp", icon: "bank" },
  { id: "ms4", category: "Compliance", name: "Annual Audit", price: 15000, desc: "Statutory audit by CA", shortName: "Audit", icon: "bank" },
  { id: "ms5", category: "Tax", name: "Income Tax Return (Co)", price: 6000, desc: "Corporate ITR filing", shortName: "ITR", icon: "briefcase" },
  { id: "ms6", category: "Tax", name: "TDS Returns (Quarterly)", price: 4000, desc: "4 quarters TDS filing", shortName: "TDS Return", icon: "briefcase" },
  { id: "ms7", category: "Trademark", name: "Trademark Registration", price: 8500, desc: "Class 1 trademark application", shortName: "Trademark", icon: "fileCheck" },
  { id: "ms8", category: "Startup India", name: "Startup India Recognition", price: 5000, desc: "DPIIT recognition certificate", shortName: "Startup", icon: "rocket" },
  { id: "ms9", category: "MSME", name: "MSME/Udyam Registration", price: 1500, desc: "Udyam certificate", shortName: "MSME", icon: "building" },
  { id: "ms10", category: "Payroll", name: "Payroll Processing (Monthly)", price: 2000, desc: "Monthly payroll & compliance", shortName: "Payroll", icon: "users" },
];

// ─── DOCUMENT FIELD TYPES ─────────────────────────────────────────────
export const FIELD_TYPES = [
  { id: "text",     label: "Text"         },
  { id: "number",   label: "Number"       },
  { id: "date",     label: "Date"         },
  { id: "email",    label: "Email"        },
  { id: "tel",      label: "Phone"        },
  { id: "select",   label: "Dropdown"     },
  { id: "textarea", label: "Long Text"    },
];

// ─── MASTER DOCUMENT TEMPLATES ────────────────────────────────────────
// HARDCODED seed catalog — commented out for runtime; templates now live in
// org_settings via GET/PUT /api/document-templates (Document Templates settings).
// Kept for reference / optional seed scripts only.
/*
export const DEFAULT_DOC_TEMPLATES = {
  "dsc_creation": {
    id: "dsc_creation",
    name: "DSC Creation",
    collectionType: "director",
    infoFields: [
      { id: "if1", label: "Full Name (as per PAN)",   type: "text",     required: true  },
      { id: "if2", label: "Father's Name",            type: "text",     required: true  },
      { id: "if3", label: "Date of Birth",            type: "date",     required: true  },
      { id: "if4", label: "Gender",                   type: "select",   required: true,  options: ["Male","Female","Other"] },
      { id: "if5", label: "PAN Number",               type: "text",     required: true  },
      { id: "if6", label: "Mobile Number",            type: "tel",      required: true  },
      { id: "if7", label: "Email Address",            type: "email",    required: true  },
      { id: "if8", label: "Residential Address",      type: "textarea", required: true  },
      { id: "if9", label: "Pincode",                  type: "number",   required: true  },
    ],
    docSlots: [
      { id: "ds1", label: "PAN Card",                  required: true  },
      { id: "ds2", label: "Aadhaar Card (Front Side)", required: true  },
      { id: "ds3", label: "Aadhaar Card (Back Side)",  required: true  },
      { id: "ds4", label: "Passport Size Photo",       required: true  },
      { id: "ds5", label: "Specimen Signature",        required: true  },
      { id: "ds6", label: "Address Proof (Utility Bill / Rent Agreement)", required: true },
    ],
  },
  "name_approval": {
    id: "name_approval",
    name: "Name Approval",
    collectionType: "common",
    infoFields: [
      { id: "if1", label: "Proposed Name Option 1",   type: "text",     required: true  },
      { id: "if2", label: "Proposed Name Option 2",   type: "text",     required: false },
      { id: "if3", label: "Proposed Name Option 3",   type: "text",     required: false },
      { id: "if4", label: "Main Business Activity",   type: "textarea", required: true  },
      { id: "if5", label: "Secondary Activity (if any)", type: "textarea", required: false },
    ],
    docSlots: [],
  },
  "main_application": {
    id: "main_application",
    name: "Main Application Filing",
    collectionType: "common",
    infoFields: [
      { id: "if1", label: "Registered Office Address (Full)",  type: "textarea", required: true  },
      { id: "if2", label: "Pincode",                           type: "number",   required: true  },
      { id: "if3", label: "State",                             type: "select",   required: true,  options: ["Maharashtra","Karnataka","Delhi","Tamil Nadu","Gujarat","Telangana","West Bengal","Rajasthan","Other"] },
      { id: "if4", label: "Authorised Share Capital (₹)",     type: "number",   required: true  },
      { id: "if5", label: "Paid-up Share Capital (₹)",        type: "number",   required: true  },
    ],
    docSlots: [
      { id: "ds1", label: "Proof of Registered Office (Rent Agreement / Sale Deed)", required: true  },
      { id: "ds2", label: "NOC from Property Owner",           required: true  },
      { id: "ds3", label: "Utility Bill of Office (Electricity / Gas)", required: true },
    ],
  },
  "gst_registration": {
    id: "gst_registration",
    name: "GST Registration",
    collectionType: "common",
    infoFields: [
      { id: "if1", label: "Nature of Business",     type: "select",   required: true, options: ["Manufacturer","Trader","Service Provider","Both Goods & Services"] },
      { id: "if2", label: "Annual Turnover (approx ₹)", type: "number", required: true },
      { id: "if3", label: "Business Commencement Date", type: "date",  required: true },
      { id: "if4", label: "Bank Account Number",    type: "text",     required: true  },
      { id: "if5", label: "Bank IFSC Code",         type: "text",     required: true  },
      { id: "if6", label: "Bank Name",              type: "text",     required: true  },
    ],
    docSlots: [
      { id: "ds1", label: "Cancelled Cheque / Bank Statement",   required: true  },
      { id: "ds2", label: "Business Address Proof",              required: true  },
      { id: "ds3", label: "Electricity Bill of Business Premises", required: true },
    ],
  },
  "form_8_llp": {
    id: "form_8_llp",
    name: "Form 8 — LLP Statement of Accounts",
    collectionType: "common",
    infoFields: [
      { id: "if1", label: "Financial Year",        type: "select",   required: true, options: ["2024-25","2025-26","2026-27"] },
      { id: "if2", label: "Total Revenue (₹)",     type: "number",   required: true  },
      { id: "if3", label: "Total Expenses (₹)",    type: "number",   required: true  },
      { id: "if4", label: "Net Profit/Loss (₹)",   type: "number",   required: true  },
    ],
    docSlots: [
      { id: "ds1", label: "Audited Financials / P&L Statement",  required: true  },
      { id: "ds2", label: "Balance Sheet",                       required: true  },
    ],
  },
};
*/
export const DEFAULT_DOC_TEMPLATES = {};

// ─── SERVICE BUNDLES ──────────────────────────────────────────────────
// HARDCODED seed bundles — commented out; runtime data from GET /api/bundles.
/*
export const DEFAULT_BUNDLES = [
  {
    id: "b1",
    name: "LLP Registration",
    description: "Complete LLP incorporation service",
    lineItems: [
      { id: "li1", name: "Name Application Govt Fees",  type: "govt",    price: 200,  gst: false, unit: "fixed",    sac: "999799", tasks: [] },
      { id: "li2", name: "Main Application Govt Fees",  type: "govt",    price: 450,  gst: false, unit: "fixed",    sac: "999799", tasks: [] },
      { id: "li3", name: "DSC Token",                   type: "dsc",     price: 850,  gst: true,  unit: "per_unit", sac: "998315",
        tasks: [{ name: "DSC Creation for Director {n}", autoFromQty: true, requirementType: "form_docs", docTemplateId: "dsc_creation" }]
      },
      { id: "li4", name: "DSC Association Charges",     type: "service", price: 1271, gst: true,  unit: "per_unit", sac: "998211", tasks: [] },
      { id: "li5", name: "LLP Professional Charges",    type: "service", price: 850,  gst: true,  unit: "fixed",    sac: "998211",
        tasks: [
          { name: "Name Approval",          autoFromQty: false, requirementType: "form_docs", docTemplateId: "name_approval"    },
          { name: "Main Application Filing",autoFromQty: false, requirementType: "form_docs", docTemplateId: "main_application" },
        ]
      },
    ],
    totalApprox: 6850,
  },
  {
    id: "b2",
    name: "Private Limited Registration",
    description: "Complete Pvt Ltd company incorporation",
    lineItems: [
      { id: "li6",  name: "Name Application Govt Fees",  type: "govt",    price: 200,  gst: false, unit: "fixed",    tasks: [] },
      { id: "li7",  name: "Main Application Govt Fees",  type: "govt",    price: null, gst: false, unit: "fixed",    tasks: [], note: "State-wise — enter manually" },
      { id: "li8",  name: "DSC Token",                   type: "dsc",     price: 850,  gst: true,  unit: "per_unit",
        tasks: [{ name: "DSC Creation for Director {n}", autoFromQty: true, requirementType: "form_docs", docTemplateId: "dsc_creation" }]
      },
      { id: "li9",  name: "DSC Association Charges",     type: "service", price: 1271, gst: true,  unit: "per_unit", tasks: [] },
      { id: "li10", name: "Professional Charges",        type: "service", price: 850,  gst: true,  unit: "fixed",
        tasks: [
          { name: "Name Approval",          autoFromQty: false, requirementType: "form_docs", docTemplateId: "name_approval"    },
          { name: "Main Application Filing",autoFromQty: false, requirementType: "form_docs", docTemplateId: "main_application" },
        ]
      },
    ],
    totalApprox: null,
  },
];
*/
export const DEFAULT_BUNDLES = [];

// ─── TASK STATUSES ────────────────────────────────────────────────────
export const TASK_STATUSES = [
  { id: "open",              label: "Open",                    color: "#6B7280", bg: "#F9FAFB" },
  { id: "team_action",       label: "Team Action Pending",     color: "#D97706", bg: "#FFFBEB" },
  { id: "payment_pending",   label: "Payment Pending",         color: "#DC2626", bg: "#FEF2F2" },
  { id: "client_action",     label: "Client Action Pending",   color: "#2563EB", bg: "#EFF6FF" },
  { id: "team_approval",     label: "Pending Team Approval",   color: "#7C3AED", bg: "#F5F3FF" },
  { id: "govt_approval",     label: "Pending Govt Approval",   color: "#0369A1", bg: "#F0F9FF" },
  { id: "completed",         label: "Completed",               color: "#16A34A", bg: "#F0FDF4" },
  { id: "cancelled",         label: "Cancelled",               color: "#9CA3AF", bg: "#F9FAFB" },
  { id: "unpaid",            label: "Unpaid",                     color: "#DC2626", bg: "#FEF2F2" },
  { id: "overdue",           label: "Overdue",                    color: "#B91C1C", bg: "#FEE2E2" },
  { id: "pending_review",    label: "Received — Pending Approval", color: "#D97706", bg: "#FFFBEB" },
  { id: "pending_approval",  label: "Pending Team Approval",       color: "#D97706", bg: "#FFFBEB" },
  { id: "partial",           label: "Partially Paid",             color: "#2563EB", bg: "#EFF6FF" },
  { id: "paid",              label: "Received",                   color: "#16A34A", bg: "#F0FDF4" },
];

export const TASK_REQUIREMENT_TYPES = [
  { id: "none",     label: "No Action Needed" },
  { id: "form",     label: "Form to be Filled (Google/Zoho)" },
  { id: "docs",     label: "Documents to be Attached" },
  { id: "form_docs",label: "Form + Documents" },
];

export const BUSINESS_TYPES = [
  "Private Limited",
  "Public Limited",
  "LLP",
  "OPC",
  "Partnership",
  "Proprietorship",
  "Individual",
  "Trust",
  "Section 8",
];

// ─── DEFAULT ROLE PERMISSIONS ─────────────────────────────────────────
// Code-level fallback used by can() when no matching role row exists in the
// app_roles table. Admins are always allowed; roles not listed here fall
// through to permissive. This guarantees the baseline policy:
//   Employees → create + edit on invoices, tasks, cross-sell & marketplace;
//               NO delete anywhere.
export const DEFAULT_ROLE_PERMISSIONS = {
  employee: {
    clients:         { view: true,  create: false, edit: true,  delete: false },
    invoices:        { view: true,  create: true,  edit: true,  delete: false },
    payments:        { view: true,  create: true,  edit: true,  delete: false },
    tasks:           { view: true,  create: true,  edit: true,  delete: false },
    recurring_tasks: { view: true,  create: true,  edit: true,  delete: false },
    tickets:         { view: true,  create: true,  edit: true,  delete: false },
    marketplace:     { view: true,  create: true,  edit: true,  delete: false },
    cross_sell:      { view: true,  create: true,  edit: true,  delete: true },
    team_reports:    { view: true,  create: false, edit: false, delete: false },
  },
  client: {
    clients:         { view: true,  create: false, edit: false, delete: false },
    invoices:        { view: true,  create: false, edit: false, delete: false },
    payments:        { view: true,  create: false, edit: false, delete: false },
    tasks:           { view: true,  create: false, edit: false, delete: false },
    recurring_tasks: { view: false, create: false, edit: false, delete: false },
    tickets:         { view: true,  create: true,  edit: false, delete: false },
    marketplace:     { view: true,  create: true,  edit: false, delete: false },
    cross_sell:      { view: false, create: false, edit: false, delete: false },
    team_reports:    { view: false, create: false, edit: false, delete: false },
  },
};

// ─── OTP (Firebase Phone Auth) ────────────────────────────────────────
// Implementation: src/core/otp-service.js
export { OTPService } from './otp-service';

// Legacy MSG91 keys kept for reference only — not used by OTPService anymore.
export const MSG91_CONFIG = {
  AUTH_KEY: process.env.REACT_APP_MSG91_AUTH_KEY || '',
  TEMPLATE_ID: process.env.REACT_APP_MSG91_TEMPLATE_ID || '',
};

// ─── KRAYA WHATSAPP SERVICE ───────────────────────────────────────────
const krayaRuntime = {
  apiUrl: process.env.REACT_APP_KRAYA_URL || "https://api.kraya.io/v1/messages",
  apiToken: process.env.REACT_APP_KRAYA_TOKEN || "",
  automationEnabled: true,
};

export function configureKraya({ url, token, automationEnabled } = {}) {
  if (url !== undefined) krayaRuntime.apiUrl = url || krayaRuntime.apiUrl;
  if (token !== undefined) krayaRuntime.apiToken = token || "";
  if (automationEnabled !== undefined) krayaRuntime.automationEnabled = automationEnabled !== false;
}

export const KRAYA = {
  API_URL: krayaRuntime.apiUrl,
  API_TOKEN: krayaRuntime.apiToken,
  TEMPLATES: {
    TASK_ACTION_NEEDED: "fb_task_action_needed",
    TASK_COMPLETED:     "fb_task_completed",
    INVOICE_CREATED:    "fb_invoice_created",
    PAYMENT_RECEIVED:   "fb_payment_received",
    WELCOME_CLIENT:     "fb_welcome_client",
    TEAM_ALERT:         "fb_team_alert",
  },
  async send(phone, template, vars = []) {
    if (!krayaRuntime.automationEnabled) {
      console.log(`📲 WhatsApp [OFF] skipped → ${phone} | ${template}`);
      return { success: true, skipped: true };
    }
    const apiToken = krayaRuntime.apiToken || process.env.REACT_APP_KRAYA_TOKEN || "";
    const apiUrl = krayaRuntime.apiUrl || process.env.REACT_APP_KRAYA_URL || "https://api.kraya.io/v1/messages";
    if (!apiToken) {
      console.log(`📲 WhatsApp [DEMO] → ${phone} | ${template} | ${vars.join(", ")}`);
      return { success: true, demo: true };
    }
    try {
      await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${apiToken}` },
        body: JSON.stringify({
          to: `91${phone.replace(/\D/g, "")}`,
          type: "template",
          template: {
            name: template,
            language: { code: "en" },
            components: vars.length ? [{ type: "body", parameters: vars.map(v => ({ type: "text", text: String(v) })) }] : [],
          },
        }),
      });
    } catch (e) { console.error("WhatsApp error:", e); }
  },
  taskActionNeeded: (phone, clientName, taskName) =>
    KRAYA.send(phone, KRAYA.TEMPLATES.TASK_ACTION_NEEDED, [clientName, taskName]),
  taskCompleted: (phone, taskName, clientName) =>
    KRAYA.send(phone, KRAYA.TEMPLATES.TASK_COMPLETED, [taskName, clientName]),
  invoiceCreated: (phone, clientName, amount, invoiceNo) =>
    KRAYA.send(phone, KRAYA.TEMPLATES.INVOICE_CREATED, [clientName, amount, invoiceNo]),
  paymentReceived: (phone, name, amount, invoiceNo) =>
    KRAYA.send(phone, KRAYA.TEMPLATES.PAYMENT_RECEIVED, [name, amount, invoiceNo]),
  welcomeClient: (phone, name) =>
    KRAYA.send(phone, KRAYA.TEMPLATES.WELCOME_CLIENT, [name]),
  teamAlert: (phone, message) =>
    KRAYA.send(phone, KRAYA.TEMPLATES.TEAM_ALERT, [message]),
};
